'use strict';

// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };

exports.hasReducedMotionListener = hasReducedMotionListener;
exports.prefersReducedMotion = prefersReducedMotion;
//# sourceMappingURL=state.cjs.map
